// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mapValues<R, T extends Record<string, any>>(
  callback: (input: T[keyof T]) => R,
  object: T
) {
  return Object.fromEntries(
    Object.entries(object).map(([key, value]) => [key, callback(value)])
  ) as Record<keyof T, R>;
}
